import { render, staticRenderFns } from "./result-page2.vue?vue&type=template&id=254556d2"
import script from "./result-page2.vue?vue&type=script&lang=js"
export * from "./result-page2.vue?vue&type=script&lang=js"
import style0 from "./result-page2.vue?vue&type=style&index=0&id=254556d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports